import { observable, action, makeObservable } from 'mobx';

class ModalParams {
	@observable isOpen = false;
	@observable loading = false;
	@observable data = {};
	onClose = null;
	onOpen = null;

	constructor({ ...props }) {
		makeObservable(this);
		if (props.onClose) {
			this.onClose = props.onClose;
			this.onOpen = props.onOpen;
		}
	}

	@action.bound
	open(data) {
		if (this.isOpen) return;
		this.data = data;
		this.setOpen(true);
		if (this.onOpen) {
			this.onOpen();
		}
	}

	@action.bound
	close = (params = null) => {
		if (!this.isOpen) return;
		this.setOpen(false);
		if (this.onClose) {
			this.onClose(params);
		}
	};

	@action.bound
	setOpen = value => {
		this.isOpen = value;
	};
}

export default ModalParams;



// WEBPACK FOOTER //
// ./src/core/models/ModalParams.js